var ShippingMethodDto = (function () {
    function ShippingMethodDto(id, name) {
        if (id === void 0) { id = ''; }
        if (name === void 0) { name = ''; }
        this.id = id;
        this.name = name;
    }
    ShippingMethodDto.fromOcapi = function (item) {
        return new ShippingMethodDto(item.shipment_id, item.name);
    };
    return ShippingMethodDto;
}());
export { ShippingMethodDto };
//# sourceMappingURL=ShippingMethodDto.js.map